import { NavLink, useLocation } from 'react-router-dom';
import { Home, MapPin, Heart, Info } from 'lucide-react';

const tabs = [
  { to: '/', icon: Home, label: 'Home' },
  { to: '/map', icon: MapPin, label: 'Map' },
  { to: '/saved', icon: Heart, label: 'Saved' },
  { to: '/info', icon: Info, label: 'Info' },
];

export const BottomTabBar = () => {
  const { pathname } = useLocation();
  if (['/admin', '/partner', '/portal', '/business/'].some(path => pathname.startsWith(path))) return null;
  return (
    <nav className="dq-bottom-nav" aria-label="Guest navigation">
      <div className="dq-bottom-nav-inner">
        {tabs.map(({ to, icon: Icon, label }) => (
          <NavLink key={to} to={to} end={to === '/'}
            className={({ isActive }) => `dq-tab${isActive ? ' dq-tab-active' : ''}`}
            data-testid={`tab-${label.toLowerCase()}`}>
            <Icon aria-hidden="true" strokeWidth={1.8} />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};
export default BottomTabBar;
